// extracted by mini-css-extract-plugin
export var fullWidthButton = "_sf-0";